import { z } from "zod";

import { auditEventTypeSchema } from "./audit-event-type";

export const auditEventHiddenFromSearchSchema = z.object({
	id: z.string(),
	createDateUTC: z.string(),
	tenantId: z.string(),
	internalUniqueId: z.string(),
	auditType: z.literal(auditEventTypeSchema.enum.HiddenFromSearch),
	alias: z.string(),
});

export type AuditEventHiddenFromSearch = z.infer<typeof auditEventHiddenFromSearchSchema>;
